module.exports = "/packs/images/homepage/activity/tennis_retina~6da6189239c5ba230ac4d3be954415ee.jpg";